<div class="container-fluid p-0">
  <div class="row g-0 discussion-wrapper">



    <div class="col-12 col-xl-4 discussion-panel bg-white p-3 border-end position-relative">
      <div class="custom-side-panel" [class.open]="isPanelOpen">

        <div class="panel-body">


          <button class="btn-close btn-close position-absolute top-0 end-0 me-2 mt-1 mb-2" (click)="closePanel()">
          </button>


          <div class="panel-header p-2" *ngIf="!isGroupMode">
            <div class="search-wrapper d-flex align-items-center px-2 py-1 border rounded shadow-sm mt-4">
              <i class="bi bi-search text-dark me-2"></i>
              <input type="text" class="form-control border-0 p-0 shadow-none" [formControl]="searchListControl"
                placeholder="Search here...">
            </div>
          </div>

          <div class="row g-3 align-items-end p-2" *ngIf="!isGroupMode" [formGroup]="filterForm">


            <div [ngClass]="staffColumn" *ngIf="showListType">
              <label class="form-label fw-bold">Select Type</label>
              <select class="form-select" formControlName="listType">
                <option [ngValue]="null" disabled>Select</option>

                <option *ngFor="let type of allowedListTypes" [ngValue]="type">
                  {{ type | titlecase }}
                </option>

              </select>
            </div>


            <div class="col-md-8" *ngIf="showClassSection">
              <div class="row g-2">

                <div class="col-md-6">
                  <label class="form-label fw-bold">Class</label>
                  <select class="form-select" formControlName="classId">
                    <option [ngValue]="null" disabled>Select Class</option>
                    <option *ngFor="let c of classList" [ngValue]="c.classId">
                      {{ c.className }}
                    </option>
                  </select>
                </div>

                <div class="col-md-6">
                  <label class="form-label fw-bold">Section</label>


                  <div *ngIf="loadingSections" class="spinner-border spinner-border-sm text-primary me-2 ms-2"
                    role="status">
                  </div>

                  <select class="form-select" formControlName="sectionId"
                    [disabled]="loadingSections || sectionList.length === 0" [ngClass]="{
                'disabled-select': loadingSections || sectionList.length === 0
            }">

                    <option [ngValue]="null" disabled>
                      {{ loadingSections ? 'Loading sections...' :
                      (sectionList.length === 0 ? 'No sections available' : 'Select Section') }}
                    </option>

                    <option *ngFor="let s of sectionList" [ngValue]="s.sectionId">
                      {{ s.sectionName }}
                    </option>

                  </select>
                </div>


              </div>
            </div>

          </div>



        </div>

        <div class="d-flex justify-content-end p-2">


          <button *ngIf="selectedCount < 2 && !isGroupMode" type="button"
            class="universal-submit-btn d-flex align-items-center justify-content-center" [disabled]="chatCreating"
            (click)="onCreateChat()">

            <ng-container *ngIf="!chatCreating">
              <i class="bi bi-chat-dots me-2"></i>
              Create Chat
            </ng-container>

            <ng-container *ngIf="chatCreating">
              <span class="spinner-border spinner-border-sm me-2"></span>
              Creating...
            </ng-container>

          </button>


          <button *ngIf="selectedCount >= 2 && !isGroupMode && !isSingleSelectMode" type="button"
            class="universal-submit-btn d-flex align-items-center" (click)="enterGroupMode()">
            <i class="bi bi-people-fill me-2"></i>
            Add Group
          </button>

        </div>


        <div *ngIf="userList.length  && !isGroupMode && !isSingleSelectMode"
          class="d-flex justify-content-between align-items-center mb-2 px-3">


          <div class="fw-bold">
            {{ selectedCount > 0 ? (selectedCount + ' selected') : '' }}
          </div>


          <label class="d-flex align-items-center ms-auto position-relative">
            <input type="checkbox" [checked]="allSelected()" (change)="toggleSelectAll($event)" class="d-none">
            <i class="bi bi-check-circle-fill check-icon" [class.checked]="allSelected()"></i>
            <span class="ms-2 fw-semibold">Select All</span>
          </label>

        </div>


        <div *ngIf="!isGroupMode" class="list-group list-group-flush chat-list" (scroll)="onUserListScroll($event)"
          >

          <div *ngIf="userListLoading" class="loader-container">
            <div class="loader"></div>
          </div>


          <ul *ngIf="!isGroupMode && !userListLoading && userList.length > 0"
            class="list-group list-group-flush ">

            <li *ngFor="let user of userList"
              class="list-group-item d-flex justify-content-between align-items-center p-2 border-0">

              <div class="d-flex align-items-center">
                <img [src]="user.profileImage" alt="Profile" class="rounded-circle me-3" width="25" height="25"
                  style="object-fit: contain;">
                <div class="fw-semibold desc">{{ user.userName }}</div>
              </div>

              <label class="position-relative" (click)="toggleSelection(user)">
                <i class="bi bi-check-circle-fill check-icon" [class.checked]="user.selected"></i>
              </label>

            </li>

          </ul>



          <!-- NO USER FOUND -->
          <div *ngIf="!userListLoading && userList.length === 0" class="no-user-wrapper">
            <img src="assets/SchoolModule/images/no-user-found.png" class="no-user-found">
          </div>


        </div>


        <div *ngIf="isGroupMode" class="p-3" [formGroup]="discussionForm">


          <div class="mb-3">
            <label class="form-label fw-semibold">Group Name</label>
            <input type="text" class="form-control" placeholder="Enter group name"
              [formControl]="discussionForm.controls.discTitle">
            <div *ngIf="discussionForm.get('discTitle')?.touched && discussionForm.get('discTitle')?.invalid"
              class="text-danger text-sm">
              Group Name is required.
            </div>
          </div>

          <div class="mb-3">
            <label class="form-label fw-semibold">Description</label>
            <textarea class="form-control" rows="3" placeholder="Enter group description"
              [formControl]="discussionForm.controls.discDesc"></textarea>
          </div>

          <div class="form-check my-2">
            <input class="form-check-input" type="checkbox" [formControl]="discussionForm.controls.canMembersPost">
            <label class="form-check-label">Allow members to post</label>
          </div>


          <div class="d-flex justify-content-end gap-2 mt-3">


            <button class="universal-cancel-btn" (click)="exitGroupMode()">
              Cancel
            </button>

            <button type="button" class="universal-submit-btn d-flex align-items-center justify-content-center"
              [disabled]="groupChatCreating" (click)="createGroupChat()">

              <ng-container *ngIf="!groupChatCreating">
                <i class="bi bi-people-fill me-2"></i>
                Create Group
              </ng-container>

              <ng-container *ngIf="groupChatCreating">
                <span class="spinner-border spinner-border-sm me-2"></span>
                Creating Group...
              </ng-container>

            </button>


          </div>


        </div>


      </div>




      <div class="d-flex justify-content-between align-items-center mb-3">

        <h5 class="fw-semibold mb-0">Discussion</h5>

        <div class="d-flex align-items-center gap-2">

          <img src="assets/SchoolModule/icons/addchat.svg" alt="Add Discussion" width="25" height="25" class="me-0"
            (click)="openCreateModal()">


          <!-- <i class="bi bi-funnel-fill fs-4" id="filterIcon" style="cursor: pointer;" (click)="toggleFilter()"></i> -->

        </div>
      </div>

      <div class="col-md-12">
        <div class="position-relative ">
          <input type="text" class="form-control ps-5" placeholder="Search by Name or Group Name..."
            [formControl]="searchControl" />
          <i class="bi bi-search position-absolute top-50 translate-middle-y"
            style="left: 14px; color: #6c757d; font-size: 1rem;"></i>
        </div>
      </div>


      <div class="chat-list-container" (scroll)="onDiscussionScroll($event)">
        <div *ngIf="discussionLoading" class="loader-container">
          <div class="loader"></div>
        </div>
        <ul class="list-group mt-3"
          *ngIf="!discussionLoading && discussions && discussions.length > 0; else noDiscussion">

          <li *ngFor="let d of discussions; let i = index"
            class="list-group-item d-flex align-items-center border-0 rounded"
            [class.selected]="selectedDiscussionId === d.discussionId" (click)="onDiscussionSelected(d)">

            <img [src]="getDiscussionIcon(d)" class="rounded-circle object-fit-cover me-3" width="25" height="25" />

            <div class="flex-grow-1">
              <div class="fw-semibold">
                {{ d.displayName || 'Private Chat' }}
              </div>

              <div class="small text-muted">
                {{ d.lastMessage || '' }}
              </div>
            </div>

            <div class="d-flex flex-column align-items-end ms-2">

              <small class="text-muted mb-1">
                {{ formatDiscussionTime(d.lastMessageTime) }}
              </small>


              <span *ngIf="d.unreadCount > 0 && d.discussionId !== selectedDiscussionId"
                class="badge rounded-pill bg-success">
                {{ d.unreadCount }}
              </span>


            </div>

          </li>

        </ul>
      </div>

      <ng-template #noDiscussion>
        <div *ngIf="!discussionLoading" class="text-center text-muted mt-4">
          No discussion found
        </div>
      </ng-template>


    </div>
    <div class="col-12 col-xl-8 chat-panel bg-light p-0 d-flex flex-column">

      <div class="d-flex justify-content-between align-items-center p-3 border-bottom bg-white">


        <div class="d-flex align-items-center gap-3">

          <img [src]="chatHeaderImage" class="rounded-circle  profile-img" (error)="onImageError($event)" width="25"
            height="25">

          <div>
            <h6 class="mb-0 fw-semibold">{{ chatTitle }}</h6>
            <small class="text-muted" *ngIf="chatSubtitle">{{ chatSubtitle }}</small>
          </div>

        </div>


        <!-- RIGHT: ICONS -->
        <div class="d-flex align-items-center gap-3 fs-5">
          <i class="bi bi-search" style="cursor:pointer;" (click)="toggleMessageSearch()"></i>

          <div *ngIf="showMessageSearch" class="d-flex align-items-center gap-2 bg-white rounded">

            <input type="text" class="form-control" placeholder="Search messages..." [(ngModel)]="searchMessageText"
              (ngModelChange)="onMessageSearchChange($event)">

            <!-- Prev -->
            <button class="btn btn-light" [disabled]="currentMatchIndex === 0 || searchResults.length === 0"
              (click)="gotoPrevMatch()">
              <i class="bi bi-arrow-up-short fs-4"></i>
            </button>

            <!-- Next -->
            <button class="btn btn-light"
              [disabled]="currentMatchIndex === searchResults.length - 1 || searchResults.length === 0"
              (click)="gotoNextMatch()">
              <i class="bi bi-arrow-down-short fs-4"></i>
            </button>

            <!-- Close -->
            <button class="btn btn-light" (click)="closeSearch()">
              <i class="bi bi-x-lg"></i>
            </button>

          </div>
          <i *ngIf="isGroupChat" class="bi bi-people-fill" style="cursor:pointer;" (click)="openParticipantsModal()">
          </i>
          <div class="dropdown" *ngIf="isGroupChat">
            <i class="bi bi-three-dots-vertical fs-5" style="cursor:pointer;" data-bs-toggle="dropdown"></i>

            <ul class="dropdown-menu dropdown-menu-end">
              <li>
                <button class="dropdown-item" (click)="openEditModal()">
                  <i class="bi bi-pencil-square me-2"></i>Edit Group Info
                </button>
              </li>
              <li *ngIf="canManageGroupMembers()">
                <button class="dropdown-item" (click)="openAddMembersModal()">
                  <i class="bi bi-person-plus-fill me-2"></i>Add Member
                </button>
              </li>

              <li *ngIf="canManageGroupMembers()">
                <hr class="dropdown-divider">
              </li>

              <li *ngIf="canManageGroupMembers()">
                <button
                  class="dropdown-item text-danger"
                  [disabled]="deletingGroup"
                  (click)="deleteCurrentGroup()">
                  <span
                    *ngIf="deletingGroup"
                    class="spinner-border spinner-border-sm me-2">
                  </span>
                  <i
                    *ngIf="!deletingGroup"
                    class="bi bi-trash3-fill me-2">
                  </i>
                  {{ deletingGroup ? 'Removing Group...' : 'Remove Group' }}
                </button>
              </li>
            </ul>
          </div>

        </div>
      </div>


      <div class="flex-grow-1 p-3 overflow-auto chat-body">
        <div *ngIf="isChatLoading || isMsgGrouping" class="d-flex justify-content-center mt-5">
          <div class="spinner-border text-primary" style="width: 2.5rem; height: 2.5rem;"></div>
        </div>

        <ng-container *ngIf="!isChatLoading && !isMsgGrouping && groupedMessages.length > 0">
          <div #chatContainer class="chat-scroll-container" (scroll)="onScroll($event)"
            style="height: 80vh; overflow-y: auto; scrollbar-width: none;">

            <ng-container *ngFor="let group of groupedMessages">
              <div class="text-center text-muted fw-semibold mb-3">
                {{ group.label }}
              </div>


              <div *ngFor="let msg of group.messages">


                <div *ngIf="!isOwnMessage(msg.postedBy, msg) else ownMsgTemplate" class="d-flex flex-column mb-4"
                  style="max-width: 75%;">
                  <div class="d-flex">
                    <img [src]="getUserImage(msg.postedBy)" class="rounded-circle profile-img-sm me-2"
                      (error)="onImageError($event)">
                    <div>
                      <!-- Show username if the masterType includes 'Group' -->
                      <div *ngIf="isGroupChat" class="fw-bold mb-1">
                        {{ msg.userName }}
                      </div>

                      <div class="incoming-msg p-3 fw-semibold">
                        <ng-container *ngIf="isMessageDeleted(msg); else incomingMessageContent">
                          <span class="text-muted fst-italic"><i class="bi bi-slash-circle me-1"></i>This message was deleted</span>
                        </ng-container>
                        <ng-template #incomingMessageContent>
                          <audio *ngIf="isAudioMessage(msg)" controls preload="none" [src]="getMessageAttachmentUrl(msg)"
                            style="max-width:100%; display:block;"></audio>
                          <a *ngIf="getMessageAttachmentUrl(msg) && !isAudioMessage(msg)"
                            [href]="getMessageAttachmentUrl(msg)" target="_blank" rel="noopener noreferrer"
                            class="d-block text-break" [attr.download]="getMessageAttachmentName(msg)">
                            <img *ngIf="isImageMessage(msg)" [src]="getMessageAttachmentUrl(msg)"
                              alt="Attached image" style="max-width:220px; max-height:180px; object-fit:contain; display:block;">
                            <i class="bi bi-paperclip me-1"></i>{{ getMessageAttachmentName(msg) }}
                          </a>
                          <span class="msg-text d-block" *ngIf="msg.discDesc">{{ msg.discDesc }}</span>
                        </ng-template>
                      </div>
                    </div>
                  </div>
                  <small class="text-muted ms-5 fw-semibold">{{ msg.createdOn | date:'shortTime' }}</small>
                </div>


                <ng-template #ownMsgTemplate>
                  <div class="d-flex flex-column mb-4 align-items-end message-wrapper"
                    [ngClass]="{ 'editing': editMessageId === msg.detailId }"
                    style="max-width: 75%; margin-left:auto; position: relative;">

                    <div class="hover-actions d-flex gap-1 shadow rounded" *ngIf="!isMessageDeleted(msg)">
                      <i class="bi bi-pencil" *ngIf="!getMessageAttachmentUrl(msg)" (click)="startEdit(msg)"></i>
                      <i class="bi bi-trash text-danger" (click)="deleteMessage(msg)"></i>
                    </div>


                    <div *ngIf="editMessageId !== msg.detailId" class="outgoing-msg p-3 fw-medium">
                      <ng-container *ngIf="isMessageDeleted(msg); else outgoingMessageContent">
                        <span class="text-muted fst-italic"><i class="bi bi-slash-circle me-1"></i>You deleted this message</span>
                      </ng-container>
                      <ng-template #outgoingMessageContent>
                        <audio *ngIf="isAudioMessage(msg)" controls preload="none" [src]="getMessageAttachmentUrl(msg)"
                          style="max-width:100%; display:block;"></audio>
                        <a *ngIf="getMessageAttachmentUrl(msg) && !isAudioMessage(msg)"
                          [href]="getMessageAttachmentUrl(msg)" target="_blank" rel="noopener noreferrer"
                          class="d-block text-break" [attr.download]="getMessageAttachmentName(msg)">
                          <img *ngIf="isImageMessage(msg)" [src]="getMessageAttachmentUrl(msg)"
                            alt="Attached image" style="max-width:220px; max-height:180px; object-fit:contain; display:block;">
                          <i class="bi bi-paperclip me-1"></i>{{ getMessageAttachmentName(msg) }}
                        </a>
                        <span class="msg-text d-block" *ngIf="msg.discDesc">{{ msg.discDesc }}</span>
                      </ng-template>
                    </div>


                    <div *ngIf="editMessageId === msg.detailId" class="edit-message-box p-3 rounded-3">
                      <textarea [(ngModel)]="editMessageText" class="form-control edit-textarea"
                        placeholder="Edit your message..."></textarea>

                      <div class="icon-container mt-2">
                        <i class="fa-solid fa-check edit-icon save text-white" (click)="saveEdit(msg)"></i>
                        <i class="fa-solid fa-xmark edit-icon cancel text-white" (click)="cancelEdit()"></i>
                      </div>
                    </div>

                    <small class="text-muted me-1 fw-semibold">{{ msg.createdOn | date:'shortTime' }}</small>
                  </div>


                </ng-template>

              </div>
            </ng-container>


            <div #bottomAnchor></div>
          </div>
        </ng-container>



      </div>


      <!-- 🟢 MESSAGE INPUT AREA (existing layout preserved) -->
      <div class="p-3 border-top bg-white" style="position:relative;">
        <input #attachmentFileInput type="file" class="d-none"
          accept="image/jpeg,image/png,image/webp,image/gif,application/pdf,text/plain,.doc,.docx,.xls,.xlsx,audio/webm,audio/ogg,audio/mp4,audio/mpeg,audio/wav"
          (change)="onAttachmentSelected($event)">

        <div *ngIf="selectedAttachment" class="d-flex align-items-center gap-2 mb-2 px-2 py-2 border rounded bg-light">
          <i class="bi bi-paperclip"></i>
          <span class="small text-truncate flex-grow-1">{{ selectedAttachment.name }}</span>
          <audio *ngIf="selectedAttachmentPreviewUrl && selectedAttachment.type.startsWith('audio/')"
            [src]="selectedAttachmentPreviewUrl" controls preload="metadata" style="height:32px; max-width:210px;"></audio>
          <button type="button" class="btn btn-sm btn-outline-danger" (click)="clearSelectedAttachment()"
            [disabled]="isSubmitting" aria-label="Remove attachment"><i class="bi bi-x-lg"></i></button>
        </div>

        <div *ngIf="showEmojiPicker" class="p-2 border bg-white rounded shadow-sm mb-2"
          style="display:flex; flex-wrap:wrap; gap:6px; max-width:360px;">
          <button *ngFor="let emoji of emojis" type="button" class="btn btn-sm btn-light"
            style="font-size:20px;" (click)="insertEmoji(emoji)">{{ emoji }}</button>
        </div>

        <div class="d-flex align-items-center gap-2">
          <button type="button" class="btn btn-sm btn-light" (click)="toggleEmojiPicker()"
            title="Insert emoji" aria-label="Emoji"><i class="bi bi-emoji-smile fs-5"></i></button>
          <button type="button" class="btn btn-sm btn-light" (click)="openAttachmentPicker()"
            [disabled]="!selectedDiscussionId || isSubmitting || isRecording"
            title="Attach file" aria-label="Attach file"><i class="bi bi-paperclip fs-5"></i></button>
          <button type="button" class="btn btn-sm" [class.btn-danger]="isVoiceToTextListening"
            [class.btn-light]="!isVoiceToTextListening" (click)="startVoiceToText()"
            [disabled]="isRecording" title="Voice to text" aria-label="Voice to text">
            <i class="bi bi-mic fs-5"></i><span class="d-none d-md-inline small ms-1">Text</span>
          </button>
          <button type="button" class="btn btn-sm" [class.btn-danger]="isRecording"
            [class.btn-light]="!isRecording" (click)="isRecording ? stopVoiceRecording() : startVoiceRecording()"
            [disabled]="isSubmitting" title="Record voice message" aria-label="Record voice message">
            <i [class]="isRecording ? 'bi bi-stop-circle fs-5' : 'bi bi-record-circle fs-5'"></i>
          </button>

          <div class="flex-grow-1">
            <textarea #messageComposer [(ngModel)]="newMessage"
              class="form-control chat-input me-2 py-2 px-3 border-0" rows="1"
              placeholder="Type message..." (keydown)="onKeyDown($event)"
              style="resize: none; overflow-y: auto;"></textarea>
          </div>

          <button type="button" class="btn btn-sm btn-light" (click)="sendMessage()"
            [disabled]="isSubmitting || isRecording || (!newMessage.trim() && !selectedAttachment)"
            title="Send message" aria-label="Send message">
            <span *ngIf="isSubmitting" class="spinner-border spinner-border-sm"></span>
            <i *ngIf="!isSubmitting" class="bi bi-send-fill fs-4"></i>
          </button>
        </div>
        <small *ngIf="voiceStatus && (isRecording || isVoiceToTextListening)" class="text-muted mt-1 d-block">
          {{ voiceStatus }}
        </small>
      </div>
    </div>




  </div>
</div>

<div id="deletePopup" class="delete-popup-overlay">
  <div class="delete-popup-box">


    <button class="close-btn" type="button" (click)="cancelDelete()">
      &times;
    </button>

    <h5 class="fw-bold mb-2">Delete Message?</h5>
    <p class="text-muted mb-4">Are you sure you want to delete this message?</p>


    <div class="d-flex justify-content-end gap-2">
      <button class="btn btn-outline-secondary" type="button" (click)="cancelDelete()">Cancel</button>
      <button class="btn fw-bold text-white" type="button" (click)="confirmDeleteMessage()" style="background-color: red;">
        Delete
      </button>
    </div>

  </div>
</div>



<ng-template #masterModalContent>
  <div class="modal-header">
    <h5 class="modal-title">{{ discussionForm.get('discussionId')?.value ? 'Edit Discussion' : 'New Discussion' }}
    </h5>
    <button type="button" class="btn-close" aria-label="Close" (click)="masterModalRef.close()"></button>
  </div>
  <div class="modal-body">
    <form [formGroup]="discussionForm" (ngSubmit)="submitMasterForm()">
      <div class="mb-3">
        <label class="form-label">Title<span style="color: red;">*</span></label>
        <input [formControl]="discussionForm.controls.discTitle" class="form-control" />
        <div *ngIf="discussionForm.get('discTitle')?.touched && discussionForm.get('discTitle')?.invalid"
          class="text-danger text-sm">
          Title is required.
        </div>
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button class="universal-cancel-btn" (click)="masterModalRef.close()">Cancel</button>
    <button class="universal-submit-btn" [disabled]="isSubmitting" (click)="submitMasterForm()">Save</button>
  </div>
</ng-template>



<ng-template #participantsModalContent let-modal>

  <div class="modal-header d-flex align-items-center">
    <h5 class="modal-title mb-0 flex-grow-1">
      Group Participants ({{ participantsList?.length || 0 }})
    </h5>

    <div
      class="d-flex align-items-center ms-auto"
      style="gap: 14px; margin-left: auto !important;">

      <button
        *ngIf="canManageGroupMembers()"
        type="button"
        class="btn btn-sm d-flex align-items-center justify-content-center"
        style="
          width: auto;
          min-width: 88px;
          height: 28px;
          padding: 3px 9px;
          border: 0;
          border-radius: 5px;
          background: linear-gradient(90deg, #08174f 0%, #ef3f2f 100%);
          color: #ffffff;
          font-size: 11px;
          font-weight: 600;
          line-height: 1;
          white-space: nowrap;
        "
        (click)="modal.close(); openAddMembersModal()">
        <i class="bi bi-person-plus-fill me-1" style="font-size: 11px;"></i>
        Add Member
      </button>

      <button
        type="button"
        class="btn-close"
        style="margin: 0; flex: 0 0 auto;"
        aria-label="Close"
        (click)="modal.dismiss()">
      </button>
    </div>
  </div>

  <div class="modal-body">

    <div class="participants-scroll">
      <ul class="list-group">
        <li *ngFor="let user of participantsList"
          class="list-group-item d-flex align-items-center justify-content-between">

          <div class="d-flex align-items-center gap-2">
            <img [src]="user.profileImage || 'assets/SchoolModule/images/user.svg'"
              class="rounded-circle profile-img-sm" (error)="user.profileImage='assets/SchoolModule/images/user.svg'">
            <div class="d-flex flex-column">
              <span class="fw-semibold" style="font-size: 15px;">
                {{ user.userName }}
              </span>

              <span *ngIf="user.participantRole" class="text-muted" style="font-size: 13px; margin-top: -2px;">
                {{ user.participantRole }}
              </span>
            </div>

          </div>

          <div class="d-flex align-items-center gap-2">
            <span *ngIf="user.participantRole" class="badge bg-primary rounded-pill" style="font-size: 12px;">
              {{ user.participantRole }}
            </span>

            <button
              *ngIf="canRemoveParticipant(user)"
              type="button"
              class="btn btn-sm btn-outline-danger d-flex align-items-center justify-content-center"
              style="
                width: 26px;
                height: 26px;
                padding: 0;
                border-radius: 50%;
                line-height: 1;
              "
              title="Remove member"
              aria-label="Remove member"
              [disabled]="removingParticipantId === user.participantId"
              (click)="removeParticipant(user)">
              <span
                *ngIf="removingParticipantId === user.participantId"
                class="spinner-border spinner-border-sm"
                style="width: 12px; height: 12px;">
              </span>
              <i
                *ngIf="removingParticipantId !== user.participantId"
                class="bi bi-x-lg"
                style="font-size: 11px;">
              </i>
            </button>
          </div>

        </li>
      </ul>
    </div>

  </div>


</ng-template>


<ng-template #addMembersModalContent let-modal>
  <div class="modal-header">
    <h5 class="modal-title">
      Add Members to {{ chatTitle || 'Group' }}
    </h5>

    <button
      type="button"
      class="btn-close"
      aria-label="Close"
      [disabled]="addingMembers"
      (click)="modal.dismiss()">
    </button>
  </div>

  <div class="modal-body">
    <div [formGroup]="addMemberForm">
      <div class="row g-3">
        <div class="col-md-12">
          <label class="form-label fw-bold">Search Member</label>
          <div class="position-relative">
            <i
              class="bi bi-search position-absolute top-50 translate-middle-y"
              style="left: 12px; color: #6c757d;">
            </i>

            <input
              type="text"
              class="form-control ps-5"
              placeholder="Search here..."
              [formControl]="addMemberSearchControl">
          </div>
        </div>

        <div [ngClass]="addMemberShowClassSection ? 'col-md-4' : 'col-md-12'">
          <label class="form-label fw-bold">Select Type</label>
          <select class="form-select" formControlName="listType">
            <option
              *ngFor="let type of allowedListTypes"
              [ngValue]="type">
              {{ type | titlecase }}
            </option>
          </select>
        </div>

        <ng-container *ngIf="addMemberShowClassSection">
          <div class="col-md-4">
            <label class="form-label fw-bold">Class</label>
            <select class="form-select" formControlName="classId">
              <option [ngValue]="null">Select Class</option>
              <option
                *ngFor="let c of classList"
                [ngValue]="c.classId">
                {{ c.className }}
              </option>
            </select>
          </div>

          <div class="col-md-4">
            <label class="form-label fw-bold">Section</label>
            <select
              class="form-select"
              formControlName="sectionId"
              [disabled]="
                addMemberLoadingSections ||
                addMemberSectionList.length === 0
              ">
              <option [ngValue]="null">
                {{
                  addMemberLoadingSections
                    ? 'Loading sections...'
                    : addMemberSectionList.length === 0
                      ? 'No section available'
                      : 'All Sections'
                }}
              </option>

              <option
                *ngFor="let section of addMemberSectionList"
                [ngValue]="section.sectionId">
                {{ section.sectionName }}
              </option>
            </select>
          </div>
        </ng-container>
      </div>
    </div>

    <div
      *ngIf="addMemberUserList.length > 0 && !addMemberLoading"
      class="d-flex justify-content-between align-items-center mt-3 mb-2">
      <div class="fw-semibold">
        {{ selectedAddMemberIds.length }} selected
      </div>

      <label class="d-flex align-items-center position-relative">
        <input
          type="checkbox"
          class="d-none"
          [checked]="allAddMembersSelected()"
          (change)="toggleSelectAllAddMembers($event)">

        <i
          class="bi bi-check-circle-fill check-icon"
          [class.checked]="allAddMembersSelected()">
        </i>

        <span class="ms-2 fw-semibold">Select All</span>
      </label>
    </div>

    <div
      *ngIf="addMemberLoading"
      class="d-flex justify-content-center py-5">
      <div class="spinner-border text-primary"></div>
    </div>

    <div
      *ngIf="!addMemberLoading"
      class="list-group list-group-flush"
      style="max-height: 390px; overflow-y: auto;">

      <button
        *ngFor="let member of addMemberUserList"
        type="button"
        class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
        (click)="toggleAddMemberSelection(member)">

        <div class="d-flex align-items-center">
          <img
            [src]="member.profileImage"
            class="rounded-circle me-3"
            width="32"
            height="32"
            style="object-fit: cover;"
            (error)="member.profileImage='assets/SchoolModule/images/user.svg'">

          <span class="fw-semibold">
            {{ member.userName }}
          </span>
        </div>

        <i
          class="bi bi-check-circle-fill check-icon"
          [class.checked]="member.selected">
        </i>
      </button>

      <div
        *ngIf="addMemberUserList.length === 0"
        class="text-center text-muted py-5">
        No new members available for the selected type.
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button
      type="button"
      class="universal-cancel-btn"
      [disabled]="addingMembers"
      (click)="modal.dismiss()">
      Cancel
    </button>

    <button
      type="button"
      class="universal-submit-btn d-flex align-items-center justify-content-center"
      [disabled]="addingMembers || selectedAddMemberIds.length === 0"
      (click)="addSelectedMembers()">

      <ng-container *ngIf="!addingMembers">
        <i class="bi bi-person-plus-fill me-2"></i>
        Add Selected Members
      </ng-container>

      <ng-container *ngIf="addingMembers">
        <span class="spinner-border spinner-border-sm me-2"></span>
        Adding...
      </ng-container>
    </button>
  </div>
</ng-template>
